import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  styled,
  TextField,
} from '@mui/material';
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import ImageIcon from '@mui/icons-material/Image';
import SendIcon from '@mui/icons-material/Send';
import PropTypes from 'prop-types';
import './ImageSubmitForm.css';
import { useAuth } from '../../../context/AuthContext';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const ImageSubmitForm = forwardRef(
  ({ onSubmit, isPublic, assignedResidents }, ref) => {
    const { userEmail } = useAuth();
    const [formData, setFormData] = useState({
      yourName: '',
      residentId: '',
      email: '',
      // phone: '',
      comment: '',
      images: [],
    });

    useEffect(() => {
      if (!formData.email && userEmail) {
        setFormData((prevState) => ({ ...prevState, email: userEmail }));
      }
    }, [userEmail]);

    const handleChange = (e) => {
      const { name, value, files } = e.target;
      if (files) {
        setFormData((prevState) => ({ ...prevState, images: [...files] }));
      } else {
        setFormData((prevState) => ({ ...prevState, [name]: value }));
      }
    };

    const handleFormSubmit = (event) => {
      event.preventDefault();
      onSubmit(formData);
    };

    const resetFormData = () => {
      setFormData({
        yourName: '',
        email: userEmail,
        comment: '',
        images: [],
        residentId: '',
      });
    };

    useImperativeHandle(ref, () => ({
      resetFormData,
    }));

    return (
      <div>
        <form className="imageForm" onSubmit={handleFormSubmit}>
          {isPublic && (
            <input
              type="text"
              name="yourName"
              placeholder="Your Name"
              value={formData.yourName}
              onChange={handleChange}
              required
            />
          )}
          {/* <input
            type="text"
            name="residentName"
            placeholder="Resident Name"
            value={formData.residentName}
            onChange={handleChange}
            required
          /> */}
          <FormControl fullWidth margin="normal" required>
            <InputLabel id="ARLabel">Resident</InputLabel>
            <Select
              value={formData.residentId}
              onChange={handleChange}
              name="residentId"
              labelId="ARLabel"
              label="Assigned Residents"
              required
            >
              {assignedResidents?.map((resident) => (
                <MenuItem key={resident.id} value={resident.id}>
                  {resident.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            type="email"
            label="Email"
            name="email"
            placeholder="Email"
            value={userEmail}
            disabled={true}
            // onChange={handleChange}
            autoComplete="email"
            required
            style={{ marginTop: '18px', marginBottom: '18px' }}
          />

          <TextField
            type="text"
            name="comment"
            label="Comment (Optional)"
            value={formData.comment}
            onChange={handleChange}
            style={{ marginBottom: '18px' }}
          />
          <div className="imageuploadbuttonContainer">
            <Button
              className="fileUpload"
              component="label"
              variant="contained"
              id="imageUploadButton"
              tabIndex={-1}
              startIcon={<ImageIcon />}
            >
              Select Pictures
              <VisuallyHiddenInput
                type="file"
                name="image"
                accept="image/*"
                onChange={handleChange}
                required
                multiple
              />
            </Button>
          </div>
          <hr />
          <Button
            type="submit"
            component="button"
            variant="contained"
            id="sendButton"
            endIcon={<SendIcon />}
          >
            Send
          </Button>
        </form>
      </div>
    );
  },
);

ImageSubmitForm.displayName = 'ImageSubmitForm';

ImageSubmitForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isPublic: PropTypes.bool.isRequired,
  assignedResidents: PropTypes.array.isRequired,
};

export default ImageSubmitForm;
